import { toastr } from 'react-redux-toastr';
import { FUEL_DATA_COMPLETENESS_REPORT_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_POST_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_FUEL_DATA_COMPLETENESS_REPORT,
  FLAG_FUEL_DATA_COMPLETENESS_REPORT_ACTIVITY,
  POST_FUEL_DATA_COMPLETENESS_REPORT,
} from '../types';

const flagFuelDataCompletenessReportActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_FUEL_DATA_COMPLETENESS_REPORT_ACTIVITY,
    payload: flag,
  });

const postFuelDataCompletenessReport =
  (payloadIn) =>
  async (dispatch) => {
    try {
      dispatch(flagFuelDataCompletenessReportActivity(true));
      const payload = {
        fromDate: String(payloadIn.fromDate),
        toDate: String(payloadIn.toDate),
      };
      if (payloadIn.companyBusIds && payloadIn.companyBusIds.length > 0) {
        payload.companyBusIds = payloadIn.companyBusIds;
      }
      if (payloadIn.circuitId != null && payloadIn.circuitId !== '') {
        payload.circuitId = Number(payloadIn.circuitId);
      }
      if (payloadIn.circuitGroupId != null && payloadIn.circuitGroupId !== '') {
        payload.circuitGroupId = Number(payloadIn.circuitGroupId);
      }
      if (payloadIn.circuitTypes && payloadIn.circuitTypes.length > 0) {
        payload.circuitTypes = payloadIn.circuitTypes;
      }
      if (payloadIn.alertFilters && payloadIn.alertFilters.length > 0) {
        payload.alertFilters = payloadIn.alertFilters;
      }
      if (payloadIn.includeNorthChicoRoutes != null) {
        payload.includeNorthChicoRoutes = Boolean(payloadIn.includeNorthChicoRoutes);
      }
      const url = FUEL_DATA_COMPLETENESS_REPORT_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const report = await response.json();
      dispatch({
        type: POST_FUEL_DATA_COMPLETENESS_REPORT,
        payload: report,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagFuelDataCompletenessReportActivity(false));
    }
  };

const clearFuelDataCompletenessReport = () => (dispatch) =>
  dispatch({
    type: CLEAR_FUEL_DATA_COMPLETENESS_REPORT,
  });

export {
  flagFuelDataCompletenessReportActivity,
  postFuelDataCompletenessReport,
  clearFuelDataCompletenessReport,
};
